import $http from '@/api/index'

function ceshi() {
	console.log('测试成功')
}

function GetTaskStatisticsByParas(id, arr, num) {
	let options = {
		method: 'POST',
		url: 'task/GetTaskStatisticsByParas',
		requestType: 2
	}
	let params = {
// 		"TASKTYPES": [{
// 			"Name": "string",
// 			"Value": "string"
// 		}],
		"SERVERCENTERIDS": id,
		"TASKTYPES": arr,
		"DateIndex": num
	}
	return $http(options, params)
}

function GetTaskTypeList() {
	let options = {
		method: 'GET',
		url: 'task/GetTaskTypeList',
		requestType: 2
	}
	let params = {}
	return $http(options, params)
}

function GetAllServerCenter(id) {
	let options = {
		method: 'GET',
		url: 'basedata/GetAllServerCenter',
		requestType: 2
	}
	let params = {
		"keyword": id
	}
	return $http(options, params)
}

export default {
	ceshi,
	GetTaskStatisticsByParas,
	GetTaskTypeList,
	GetAllServerCenter
}
